import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getJSON, params, postJSON } from '../../shared/util';

export function* init({ payload }) {
    yield put({
        type: 'price:required',
        payload: {
            upc: payload.upc,
            placement: 'text-checkout',
        },
    });
    yield put({ type: 'cordial:cart' });
}

function* submit(data) {
    let response;
    try {
        response = yield call(postJSON, '/api/checkout/submit', params(data));
    } catch (e) {
        let error = e.body && e.body.error ||
            'An error has occurred. Please contact <a href="/service">customer support.</a>';
        yield put({
            type: 'checkout:update',
            payload: {
                submitting: false,
                error: error,
            },
        });
    }

    if (response && response.report_url) {
        yield put({ type: 'location:href', payload: response.report_url });
    }
}

export function* creditCard({ payload }) {
    yield put({
        type: 'checkout:update',
        payload: {
            submitting: true,
        },
    });

    let data = {
        password: payload.password,
        order_uuid: payload.order && payload.order.order_uuid,
        payment_method_nonce: payload.bt && payload.bt.nonce,
    };

    if (payload.type && payload.type == 'drts') {
        data['purchase-package'] = 'payment-subscription';
        data.subscription_upc = 'drt-monthly-subscription';
    } else if (payload.type) {
        data['purchase-package'] = payload.type == 'kc' ? 'payment-kc-package' : 'payment-usd';
        data['kc-package-select'] = payload.type == 'kc' && payload.package && payload.package.upc
            ? payload.package.upc
            : null;
    }

    yield call(submit, data);
}

export function* payPal({ payload }) {
    yield put({
        type: 'checkout:update',
        payload: {
            submitting: true,
        },
    });

    let error = null;
    let response;
    let url = `/api/checkout/redirect_ec?order=${payload.order_uuid}`;
    if (payload.type && payload.type == 'kc' && payload.package && payload.package.upc) {
        url = `${url}&kc-package-select=${payload.package.upc}`;
    } else if (payload.type && payload.type == 'drts') {
        url = `${url}&additional-upc=drt-monthly-subscription`;
    }

    try {
        response = yield call(getJSON, url);
    } catch (e) {
        error = 'The PayPal redirect had an error. Please retry or contact <a href="/service">customer support.</a>';
        if (e.body && e.body.error) {
            if (e.body.error.message) {
                error = e.body.error.message == 'Not Found'
                    ? 'The PayPal redirect prevented. Please retry or contact <a href="/service">customer support.</a>'
                    : e.body.error.message;
            } else {
                error = e.body.error;
            }
        }

        yield put({
            type: 'checkout:update',
            payload: {
                error: error,
                submitting: false,
            },
        });
    }

    if (response && response.redirect_url && response.redirect_url[0]) {
        document.location.href = response.redirect_url[0];
    }
}

export function* kcOnly({ payload }) {
    yield put({
        type: 'checkout:update',
        payload: {
            submitting: true,
        },
    });

    yield call(submit, payload);
}

export function* root() {
    yield all([
        takeEvery('checkout:init', init),
        takeEvery('checkout:credit-card', creditCard),
        takeEvery('checkout:paypal', payPal),
        takeEvery('checkout:kc-only', kcOnly),
    ]);
}
